import React from 'react';
import { Redirect } from 'expo-router';

export default function GivingReportingRedirect() {
    return <Redirect href="/analytics/dashboards/onlinegiving" />;
}
